
class CapChangeView {
  constructor(config) {
    this.config = config
  }

  checkPermission(options = {}) {
    if (options === undefined) {
      return Boolean(this.config)
    }

    if (options.schoolYear) {
      return this._checkConfigField('schoolYear', options)
    }
    else if (options.district) {
      return this._checkConfigField('district', options)
    }
    else if (options.partition) {
      return this._checkConfigField('partition', options)
    }
    else if (options.vendor) {
      return this._checkConfigField('vendor', options)
    }
    else {
      // options is empty
      return Boolean(this.config)
    }
  }

  displayCanChangeViewField(fieldKey) {
    if (this.config[fieldKey] === undefined) {
      return false
    }
    if (typeof this.config[fieldKey] === 'boolean') {
      return Boolean(this.config[fieldKey])
    }
    else {
      return this.config[fieldKey].canChange
    }
  }

  optionsChangeViewField(fieldKey) {
    return this.config[fieldKey].options
  }

  _checkConfigField(fieldKey, options) {
    if (this.config[fieldKey]) {
      return this.config[fieldKey].includes(options[fieldKey])
    }
    else {
      return false
    }
  }
}

function key() {
  return 'change_view'
}

function create(config) {
  return new CapChangeView(config)
}

export default {
  key,
  create,
}
